import { Component } from '@angular/core';
import { MatDialogRef } from '@angular/material/dialog';

@Component({
  selector: 'app-sim-confirmation-dialog',
  standalone: false,
  templateUrl: './sim-confirmation-dialog.component.html',
  styleUrl: './sim-confirmation-dialog.component.scss'
})
export class SimConfirmationDialogComponent {

  constructor(
      public dialogRef: MatDialogRef<SimConfirmationDialogComponent>,
    ) { }
  
    closeDialog() {
      this.dialogRef.close();
    }
  
    acceptDialog() {
      this.dialogRef.close('accepted');
    }
}
